<template>
  <!-- use the modal component, pass in the prop -->
  <modal :close="close">
    <h3 slot="header">Sign up</h3>
    <div slot="body">
      <div class="modal-body">
        <slot name="errors"></slot>
        <alert :success="success" :error="error"></alert>
        <div class="form-group">
          <input v-model="user.firstName" :placeholder="$t('signup.firstName')" autofocus class="form-control mb-20"/>
        </div>
        <input v-model="user.lastName" :placeholder="$t('signup.lastName')" class="form-control mb-20"/>
        <form-error :errors='errors' :attribute="'email'">
          <input name="email" v-model="user.email" :placeholder="$t('signup.email')" class="form-control"/>
        </form-error>
        <form-error :errors='errors' :attribute="'password'" class="position-relative">
          <input v-model="user.password" :type="passowordType" :placeholder="$t('profile.password')" class="form-control"/>
          <div class="visible_toggle">
            <button type="button" v-if="passowordType === 'password'" @click.prevent="passowordType = 'text'">
              <img src="~assets/img/ico_cross_eye.svg" alt="">
            </button>
            <button type="button" v-else @click.prevent="passowordType = 'password'">
              <img src="~assets/img/ico_eye.svg" alt="">
            </button>
          </div>
        </form-error>
        <div class="position-relative">
          <input v-model="user.confirm_password" :type="passowordConfirmType" :placeholder="$t('profile.confirmPassword')" class="form-control mb-20"/>
          <div class="visible_toggle">
            <button type="button" v-if="passowordConfirmType === 'password'" @click.prevent="passowordConfirmType = 'text'">
              <img src="~assets/img/ico_cross_eye.svg" alt="">
            </button>
            <button type="button" v-else @click.prevent="passowordConfirmType = 'password'">
              <img src="~assets/img/ico_eye.svg" alt="">
            </button>
          </div>
        </div>
        <form-error :errors='errors' :attribute="'recaptcha'">
          <vue-recaptcha @verify="onVerify" sitekey="6LfpiCQUAAAAAJpSXqBIGbQ_SsG-AK5lYnD_lt7X" class="recaptcha"></vue-recaptcha>
        </form-error>
        <checkbox v-model="subscribe">
          <span slot="label">{{ $t("signup.newsletter") }}</span>
        </checkbox>
        <p>
          {{ $t("signup.agree") }}
          <a href="/static/privacy" target="blank"> {{ $t("privacyPolicy") }}</a>
          {{ $t('and') }}
          <a href="/static/rules" target="blank"> {{ $t("signup.termsOfUse") }}</a>
        </p>
      </div>
    </div>
    <div slot="footer" style="display: inline">
      <button type="button" class="btn btn-primary" @click="submit" :disabled="success != ''">{{ $t("signup.createButton") }}</button>
    </div>
  </modal>
</template>

<script>
import auth from '@/api/v1/auth/authService';
import Alert from '@/components/Alert';
import FormError from '@/components/FormError';
import Modal from '@/components/Modal';
import Checkbox from '@/components/Utils/Inputs/Checkbox';
import VueRecaptcha from 'vue-recaptcha';

export default {
  data() {
    return {
      user: {},
      success: '',
      error: '',
      errors: {},
      recaptcha: '',
      subscribe: false,
      passowordType: 'password',
      passowordConfirmType: 'password',
    };
  },
  methods: {
    submit() {
      this.errors = {};
      this.error = '';

      if (!this.recaptcha) {
        this.errors.recaptcha = ['Wrong captcha'];
        return;
      }
      this.user.full_name = `${this.user.firstName} ${this.user.lastName}`;
      const credentials = { user: this.user };
      if (this.user.password === this.user.confirm_password) {
        // Pass the component's this context
        auth.signup(this, credentials);
      } else {
        this.error = 'Niepoprawne hasło potwierdzające';
      }
    },
    scrollToTop() {
      document.getElementById('js-modalContainer').scrollTop = 0;
    },
    onVerify(response) {
      this.recaptcha = response;
    },
  },
  components: { Alert, FormError, VueRecaptcha, Modal, Checkbox },
  props: ['close'],
};
</script>



// WEBPACK FOOTER //
// SignupModal.vue?0c8e28a0